export const environment = {
  production: true,
  apiUrl: 'https://api.halloalberta.de',
  templateBuilderUrl: 'https://tb.halloalberta.de',
};
